﻿import {
  Box,
  List,
  Modal,
  Stack,
  Typography,
  IconButton,
  ListItemText,
  Card,
  Avatar
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  FETCH_USERS_WORK_HISTORY,
  SAVE_TIMESHEETS,
  SAVE_TIMESHEETS_ENTRIES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import "./Joblist.css";
import Removeduplicates from "../common/Removeduplicate";
import Loader from "../../common/Loader";
import { getFormattedAddress } from "../common/GetFormattedAddress";
import { English } from "../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";

export default function Joblist({
  open,
  onClose,
  loginData,
  selectedJob,
  setSelectedJob,
  selectedClockInJob,
  setSelectedClokInJob,
  isClockIn,
  seletetdClockInTimesheet,
  roleIndex = 1
}) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const {
    TEXT_CHOOSE_A_PROJECT = English.TimeSheet.TEXT_CHOOSE_A_PROJECT,
    TEXT_PLEACEHOLDER = English.TimeSheet.TEXT_PLEACEHOLDER,
    TEXT_NO_COMPANY = English.TimeSheet.TEXT_NO_COMPANY
  } = LanguageData || {};

  // Self-managed state (moved from context)
  const [userSites, setUserSites] = useState([]);
  const [noCompanyUserSites, setNoCompanyUserSites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (open) {
      getUserworkhistory();
    }
  }, [open]);

  const getUserworkhistory = async () => {
    try {
      setIsLoading(true);
      const workHistoryObj = {
        FullSearch: "",
        IncludeRecordNr: false,
        SearchList: [{ Id: 0, UserId: loginData?.userInformation?.UserId }],
        NrOfRecPerPage: 0
      };
      const userSitesRes = await Postrequestcall(
        FETCH_USERS_WORK_HISTORY,
        workHistoryObj,
        loginData?.accessToken
      );

      if (userSitesRes.status === 201) {
        let userSites = Removeduplicates(userSitesRes?.data?.data, "projectId");
        let updatedUserSites = userSites.map((element) => ({
          ...element,
          siteAddress: element.address,
          siteCity: element.city,
          siteProvince: element.province,
          sitePostalCode: element.postalCode,
          siteCountry: element.country
        }));

        setNoCompanyUserSites(
          updatedUserSites.filter((comp) => comp.companyId === 0 || comp.companyName === "")
        );
        setUserSites(
          updatedUserSites.filter((comp) => comp.companyId !== 0 || comp.companyName !== "")
        );
      }
    } catch (error) {
      console.error("getUserworkhistory-> Error Getting User Work History: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddJob = async (jobData) => {
    setIsSaving(true);
    try {
      let todayTimesheetId = null;

      if (
        (selectedClockInJob.length > 0 &&
          (selectedClockInJob[0]?.timesheetId || selectedClockInJob[0]?.timeSheetId)) ||
        seletetdClockInTimesheet?.id
      ) {
        todayTimesheetId =
          selectedClockInJob[0]?.timesheetId ||
          selectedClockInJob[0]?.timeSheetId ||
          seletetdClockInTimesheet?.id;
      } else {
        const timesheetObj = {
          UserId: loginData?.userInformation?.UserId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              TimesheetDate: dayjs().format("YYYY-MM-DD"),
              TotalHours: 0,
              TotalDistance: 0,
              UnitOfDistance: roleIndex === 1 ? "km" : "mi",
              IsSent: false,
              ModifiedBy: loginData?.userInformation?.UserId,
              TimesheetTypeId: 2,
              TimesheetStatus: 0
            }
          ]
        };
        const timesheetData = await Postrequestcall(
          SAVE_TIMESHEETS,
          timesheetObj,
          loginData?.accessToken
        );
        todayTimesheetId = timesheetData?.data?.data?.[0]?.objData?.id;
      }

      // Create timesheet entry for the selected job
      const entryObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            TimesheetId: todayTimesheetId,
            SiteId: jobData.siteId,
            Hours: 0,
            Distance: jobData.distance || 0,
            UnitOfDistance: jobData.unitOfDistance || (roleIndex === 1 ? "km" : "mi"),
            Comments: jobData.comments || "",
            CompanyId: jobData.companyId,
            ModifiedBy: loginData?.userInformation?.UserId,
            ProjectId: jobData.projectId,
            ClockInTime: "00:00",
            ClockOutTime: "00:00"
          }
        ]
      };
      const entryRes = await Postrequestcall(
        SAVE_TIMESHEETS_ENTRIES,
        entryObj,
        loginData?.accessToken
      );
      const entryId = entryRes?.data?.data?.[0]?.objData?.id;

      // Store job with timesheetId, entryId, and ClockInTime in state
      const newJob = {
        ...jobData,
        timesheetId: todayTimesheetId,
        id: entryId,
        clockInTime: "00:00",
        clockOutTime: "00:00",
        hours: 0,
        distance: jobData.distance || 0,
        comments: jobData.comments || "",
        pictureList: [],
        isNew: true,
        selectedGoals: [],
        isShowimage: false
      };
      setSelectedClokInJob((prev) => [...prev, newJob]);
      onClose();
    } catch (error) {
      console.error("Clock In failed:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const selectRequiredJob = (item) => {
    const newJob = {
      ...item,
      hours: 0,
      distance: 0,
      comments: "",
      pictureList: [],
      isNew: true,
      selectedGoals: [],
      isShowimage: false
    };

    if (isClockIn) {
      handleAddJob(item);
    } else {
      setSelectedJob((prevJobs) => [...prevJobs, newJob]);
      onClose();
    }
  };

  const getAddress = (params) => {
    const userAddress = {
      city: params?.siteCity,
      country: params?.siteCountry,
      province: params?.siteProvince,
      postalCode: params?.sitePostalCode,
      address: params?.siteAddress
    };
    let { city, country, province, postalCode, address, address1 } = userAddress ? userAddress : {};
    city =
      city !== "" && city
        ? city.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
        : "";
    country =
      country !== "" && country
        ? country.replace(
            /\w*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
          )
        : "";

    const uAddress = getFormattedAddress(
      address ?? "",
      address1 ?? "",
      city ?? "",
      province ?? "",
      country ?? "",
      postalCode ?? "",
      3
    );
    return uAddress;
  };

  const handleClose = () => {
    // Reset state when closing
    setUserSites([]);
    setNoCompanyUserSites([]);
    setIsLoading(true);
    setIsSaving(false);
    onClose();
  };

  const renderJobList = (itemList) => {
    if (itemList.length === 0) {
      return (
        <Typography sx={{ p: 1 }} variant="h6">
          {TEXT_PLEACEHOLDER}
        </Typography>
      );
    }
    return itemList.map((item, index) => (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{ marginTop: "0px", padding: 1, pl: 1.5, cursor: "pointer" }}>
        <Typography variant="body1">{item.companyName}</Typography>
        <ListItem alignItems="flex-start" sx={{ m: 0, p: 0, pt: 0.5 }} key={index.toString()}>
          <ListItemButton
            alignItems="flex-start"
            sx={{ m: 0, p: 0 }}
            onClick={() => {
              selectRequiredJob(item);
            }}
            disabled={isSaving}>
            <Avatar
              className="add-Timesheet-picture"
              variant="square"
              alt="contact-PictureUrl"
              src={item?.mainPictureUrl || PlaceholderImg}
            />
            <ListItemText
              sx={{ pl: 2, mt: 0, alignItems: "flex-start" }}
              primary={
                <Typography variant="body1" maxWidth={"430px"} noWrap>
                  {item?.projectName}
                </Typography>
              }
              secondary={
                <Box>
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {item?.siteName}
                  </Typography>
                  <Typography variant="body2" maxWidth={"430px"} noWrap>
                    {getAddress(item)}
                  </Typography>
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      </Card>
    ));
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_CHOOSE_A_PROJECT}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose} disabled={isSaving}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box
          sx={{
            marginTop: "10px",
            paddingBottom: "10px",
            height: "450px",
            overflow: "auto"
          }}>
          {isLoading || isSaving ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 440
              }}>
              <Loader />
            </div>
          ) : (
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >{renderJobList(userSites)}</Stack>
              {noCompanyUserSites.length !== 0 ? (
                <>
                  <Typography sx={{ p: 1 }} variant="h6">
                    {TEXT_NO_COMPANY}
                  </Typography>
                  <Stack sx={{ gap: 1 }} >{renderJobList(noCompanyUserSites)}</Stack>
                </>
              ) : null}
            </List>
          )}
        </Box>
      </Box>
    </Modal>
  );
}

